import type { ApiResponse } from "./http";
import { apiRequest, apiUrl, queryString } from "./http";
import type {
  DocumentListParams,
  DocumentRecord,
} from "./generated/openapi";

export type { DocumentListParams, DocumentRecord } from "./generated/openapi";

async function download(id: string): Promise<ApiResponse<Blob>> {
  try {
    const response = await fetch(apiUrl(`/api/documents/${id}/content`), {
      credentials: "include",
    });
    if (!response.ok) {
      const payload = await response.json().catch(() => null);
      return {
        data: null,
        error: {
          code: payload?.error?.code,
          message: payload?.error?.message || response.statusText,
          status: response.status,
        },
      };
    }
    return { data: await response.blob(), error: null };
  } catch (error: unknown) {
    return {
      data: null,
      error: {
        message: error instanceof Error ? error.message : String(error),
      },
    };
  }
}

export const documentApi = {
  list: (params: DocumentListParams = {}) =>
    apiRequest<DocumentRecord[]>(`/api/documents${queryString(params)}`),

  upload: (
    projectId: string | number,
    file: File,
    visibleToClient = true,
  ) => {
    const body = new FormData();
    body.append("file", file);
    body.append("visible_to_client", String(visibleToClient));
    return apiRequest<DocumentRecord>(`/api/projects/${projectId}/documents`, {
      method: "POST",
      body,
    });
  },

  download,

  delete: (id: string) =>
    apiRequest<DocumentRecord>(`/api/documents/${id}`, { method: "DELETE" }),
};
